/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceDefinitionRecordsInner
 */
export interface ServiceDefinitionRecordsInner {
    /**
     * Unique identifier for the service definition
     * @type {string}
     * @memberof ServiceDefinitionRecordsInner
     */
    uuid?: string;
    /**
     * Name of the service definition
     * @type {string}
     * @memberof ServiceDefinitionRecordsInner
     */
    name?: string;
    /**
     * Description of the service definition
     * @type {string}
     * @memberof ServiceDefinitionRecordsInner
     */
    description?: string;
    /**
     * Type of service definition
     * @type {string}
     * @memberof ServiceDefinitionRecordsInner
     */
    type?: ServiceDefinitionRecordsInnerTypeEnum;
    /**
     * Array of state names for the service
     * @type {Array<string>}
     * @memberof ServiceDefinitionRecordsInner
     */
    stateNames?: Array<string>;
    /**
     * Trigger alarm setting (-1 for no alarm, 0-2 for different alarm states)
     * @type {number}
     * @memberof ServiceDefinitionRecordsInner
     */
    triggerAlarm?: number;
    /**
     * High alarm threshold (for analog types)
     * @type {number}
     * @memberof ServiceDefinitionRecordsInner
     */
    alarmHigh?: number | null;
    /**
     * Low alarm threshold (for analog types)
     * @type {number}
     * @memberof ServiceDefinitionRecordsInner
     */
    alarmLow?: number | null;
    /**
     * High warning threshold (for analog types)
     * @type {number}
     * @memberof ServiceDefinitionRecordsInner
     */
    warningHigh?: number | null;
    /**
     * Low warning threshold (for analog types)
     * @type {number}
     * @memberof ServiceDefinitionRecordsInner
     */
    warningLow?: number | null;
}


/**
 * @export
 */
export const ServiceDefinitionRecordsInnerTypeEnum = {
    Bit: 'bit',
    _2bit: '2bit',
    Analog: 'analog',
    DigitalOut: 'digital_out',
    Relay: 'relay'
} as const;
export type ServiceDefinitionRecordsInnerTypeEnum = typeof ServiceDefinitionRecordsInnerTypeEnum[keyof typeof ServiceDefinitionRecordsInnerTypeEnum];


/**
 * Check if a given object implements the ServiceDefinitionRecordsInner interface.
 */
export function instanceOfServiceDefinitionRecordsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ServiceDefinitionRecordsInnerFromJSON(json: any): ServiceDefinitionRecordsInner {
    return ServiceDefinitionRecordsInnerFromJSONTyped(json, false);
}

export function ServiceDefinitionRecordsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceDefinitionRecordsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'stateNames': !exists(json, 'state_names') ? undefined : json['state_names'],
        'triggerAlarm': !exists(json, 'trigger_alarm') ? undefined : json['trigger_alarm'],
        'alarmHigh': !exists(json, 'alarm_high') ? undefined : json['alarm_high'],
        'alarmLow': !exists(json, 'alarm_low') ? undefined : json['alarm_low'],
        'warningHigh': !exists(json, 'warning_high') ? undefined : json['warning_high'],
        'warningLow': !exists(json, 'warning_low') ? undefined : json['warning_low'],
    };
}

export function ServiceDefinitionRecordsInnerToJSON(value?: ServiceDefinitionRecordsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uuid': value.uuid,
        'name': value.name,
        'description': value.description,
        'type': value.type,
        'state_names': value.stateNames,
        'trigger_alarm': value.triggerAlarm,
        'alarm_high': value.alarmHigh,
        'alarm_low': value.alarmLow,
        'warning_high': value.warningHigh,
        'warning_low': value.warningLow,
    };
}

